export default __webpack_public_path__ + "static/media/Boots of the Firebrand.92e179e3.jpg";